import { readJson } from "@emdur/ui";
import { useEffect, useState } from "react";
import { useApi } from "../lib/apiContext";
import { type CapabilityItem, cataloguePath } from "../lib/clients";
import { errorText } from "../lib/errors";
import { useRegistry } from "./RegistryProvider";
export function useCatalogue(org: string) {
  const api = useApi();
  const [items, setItems] = useState<CapabilityItem[] | null>(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const registry = useRegistry();
  const cached = registry.catalogues[org];
  useEffect(() => {
    let current = true;
    setItems(null);
    setError("");
    if (cached || registry.loading) return;
    readJson<{ items: CapabilityItem[] }>(api.fetch, cataloguePath(org)).then(
      (answer) => {
        if (current) setItems(answer.data.items);
      },
      (failure) => {
        if (current) setError(errorText(failure));
      },
    );
    return () => {
      current = false;
    };
  }, [api.fetch, org, cached, registry.loading, attempt]);
  return { items: cached ?? items, error, reload: () => setAttempt((value) => value + 1) };
}
